var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#FFC54D;} .st1{fill:#F46262;} .st2{fill:#EDB248;} .st3{fill:#B78B6A;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "33.6,98.5 60,86.8 86.4,98.5 86.4,25.8 33.6,25.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "60,82.4 37.6,92.3 37.6,29.9 82.4,29.9 82.4,92.3 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.7,42.6l3.8,7.6c0.1,0.2,0.3,0.4,0.6,0.4l8.4,1.2c0.6,0.1,0.8,0.8,0.4,1.3L67.7,59 c-0.2,0.2-0.3,0.4-0.2,0.7l1.4,8.4c0.1,0.6-0.5,1.1-1.1,0.8l-7.5-4c-0.2-0.1-0.5-0.1-0.7,0l-7.5,4c-0.5,0.3-1.2-0.2-1.1-0.8 l1.4-8.4c0-0.2,0-0.5-0.2-0.7l-6.1-5.9c-0.4-0.4-0.2-1.2,0.4-1.3l8.4-1.2c0.2,0,0.4-0.2,0.6-0.4l3.8-7.6C59.6,42,60.4,42,60.7,42.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.9,30.7H30.1c-2.5,0-4.6-2.1-4.6-4.6v0c0-2.5,2.1-4.6,4.6-4.6h59.8c2.5,0,4.6,2.1,4.6,4.6v0 C94.5,28.7,92.5,30.7,89.9,30.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLess);
export default __webpack_public_path__ + "static/media/less.fa043da6a288b5c291b1fb583d95703d.svg";
export { ForwardRef as ReactComponent };